import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { ApiTypes, UITypes } from "types"

import { customParamsSerializer } from "utils/prepareQueryParams"

export const publicApi = createApi({
  reducerPath: "public",
  tagTypes: ["public"],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL_API,
    paramsSerializer: customParamsSerializer,
  }),
  endpoints: builder => ({
    getPublicReferralAgent: builder.query<ApiTypes.Res.PublicReferralAgent, string>({
      query: slug => {
        return {
          url: `/public/referral-agents/${slug}`,
          method: "GET",
        }
      },
    }),
    createPublicReferralClaim: builder.query<
      ApiTypes.Res.PublicReferralClaim,
      { slug: string; body: ApiTypes.Req.PublicReferralClaim }
    >({
      query: data => {
        return {
          url: `/public/referral-agents/${data.slug}/referrals`,
          method: "POST",
          body: data.body,
        }
      },
    }),
    getPublicStates: builder.query<{ data: ApiTypes.Res.Dictionary[] }, UITypes.Params>({
      query: arg => {
        return {
          url: `/public/dictionary/states`,
          method: "GET",
          params: arg,
        }
      },
    }),
    getPublicCities: builder.query<{ data: ApiTypes.Res.Dictionary[] }, UITypes.Params>({
      query: arg => {
        return {
          url: `/public/dictionary/cities`,
          method: "GET",
          params: arg,
        }
      },
    }),
  }),
})

export const {
  useLazyGetPublicReferralAgentQuery,
  useLazyCreatePublicReferralClaimQuery,
  useLazyGetPublicStatesQuery,
  useLazyGetPublicCitiesQuery,
} = publicApi
